import React, { useEffect, useMemo, useState } from "react";
import { Container, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import { Loading } from "../../share/loading";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../../share/form.css";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import { BsPlusLg } from "react-icons/bs";
import DatePicker, { registerLocale } from "react-datepicker";
import th from "date-fns/locale/th";
import { th as thBuddhist } from "date-fns/esm/locale";
import { format } from "date-fns";
import { addYears } from "date-fns/esm/fp";
import "react-datepicker/dist/react-datepicker.css";
import TextErrors from "../../share/TextErrors";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";

// ใช้ forwardRef เพื่อให้ react-datepicker ใช้ custom input ได้จริง
export const CustomBuddhistInput = React.forwardRef(
  ({ value: _ignoredByUs, displayValue, className, onClick, readOnly = true, ...rest }, ref) => {
    return (
      <Input
        type="text"
        className={className}
        value={displayValue || ""}
        onClick={onClick}
        readOnly={readOnly}
        ref={ref}
        {...rest}
      />
    );
  }
);
CustomBuddhistInput.displayName = "CustomBuddhistInput";

export function ProposedToTheSubCommittee3FormComponent() {
  registerLocale("th-buddhist", { ...th, options: { ...th.options, weekStartsOn: 1 }, formatLong: thBuddhist.formatLong });
  const range = (start, end) => new Array(end - start).fill(0).map((_, i) => i + start);
  const thaiMonths = [
    "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
    "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
  ];
  const years = range(1963, getYear(new Date()) + 8, 1);

  const [loading, setLoading] = useState(false);

  const [dataForSelect, setDataForSelect] = useState([]);              // ผู้ขอกู้ที่ยังไม่มี meetingNo
  const [employeeForChangeMeeting, setEmployeeForChangeMeeting] = useState([]); // ผู้ขอกู้ที่มี meetingNo
  const [lawOccupationData, setLawOccupationData] = useState([]);      // รายการสาขาอาชีพ

  // เก็บรายการที่เลือก (borrowId + employee + lawOccupation)
  const [detailSelectLawOccupation, setDetailSelectLawOccupation] = useState([]);

  // สถานะแก้ไข/เพิ่ม
  const [isEditing, setIsEditing] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // โมดัล “เลือกรายการ”
  const [openModalForm, setOpenModalForm] = useState(false);
  const modalToggle = () => setOpenModalForm(!openModalForm);

  // โมดัล “แก้ไขข้อมูลวันที่ประชุม”
  const [openEditMeetingModal, setOpenEditMeetingModal] = useState(false);
  const toggleEditMeetingModal = () => setOpenEditMeetingModal((s) => !s);

  // ฟิลเตอร์ในโมดัลแก้ไขวันประชุม
  const [filterMeetingNo, setFilterMeetingNo] = useState("");
  const [filterMeetingYear, setFilterMeetingYear] = useState("");

  // เก็บค่าวันที่ที่ผู้ใช้เลือกใหม่ (borrowId -> Date)
  const [pendingDates, setPendingDates] = useState({});

  let getCurrentYear = new Date().getFullYear() + 543;

  const toIsoDate = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const renderCustomHeader = ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
    return (
      <div className="react-datepicker__custom-header">
        <div className="react-datepicker__custom-header-left">
          <button type="button" className="react-datepicker__navigation react-datepicker__navigation--previous" aria-label="previous month" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" />
          </button>
        </div>
        <div className="react-datepicker__custom-header-center">
          <select value={thaiMonths[getMonth(date)]} onChange={({ target: { value } }) => changeMonth(thaiMonths.indexOf(value))}>
            {thaiMonths.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
          <select value={getYear(date)} onChange={({ target: { value } }) => changeYear(value)}>
            {years.map((option) => (
              <option key={option} value={option}>{Number(option) + 543}</option>
            ))}
          </select>
        </div>
        <div className="react-datepicker__custom-header-right">
          <button type="button" className="react-datepicker__navigation react-datepicker__navigation--next" aria-label="next month" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next" />
          </button>
        </div>
      </div>
    );
  };

  // ===== Load data =====
  useEffect(() => {
    async function GetBorrowByType() {
      setLoading(true);
      try {
        const res = await fetch("/api/ProposalBorrow/getInfoBorrowByType");
        const data = await res.json();
        setDataForSelect(data.dataenum.filter((item) => item.meetingNo == null));
        setEmployeeForChangeMeeting(data.dataenum.filter((item) => item.meetingNo != null));
      } catch (e) {
        // console.log("e => " + e);
      } finally {
        setLoading(false);
      }
    }
    GetBorrowByType();
  }, []);

  useEffect(() => {
    async function GetOccupation() {
      setLoading(true);
      try {
        const res = await fetch("/api/Borrow/getLawOcuData");
        const data = await res.json();
        setLawOccupationData(data.dataenum);
      } catch (e) {
        // console.log("e => " + e);
      } finally {
        setLoading(false);
      }
    }
    GetOccupation();
  }, []);

  // ===== Parent form =====
  const initialValues = {
    meetingNo: "1",
    meetingDate: "",
    meetingYear: "",
    detailSelectLawOccupationAr: detailSelectLawOccupation,
  };

  const validateSchema = Yup.object().shape({
    meetingNo: Yup.string().required("กรุณากรอกครั้งที่ประชุม"),
    meetingDate: Yup.date().typeError("รูปแบบไม่ถูกต้อง").required("กรุณาเลือกวันที่ประชุม"),
    meetingYear: Yup.string().required("กรุณาเลือกปีที่ประชุม"),
  });

  const onSubmit = async (values, action) => {
    if (!detailSelectLawOccupation.length) {
      Swal.fire({
        icon: "info",
        title: "กรุณาเลือกรายชื่อผู้ขอกู้ยืมเงินอย่างน้อย 1 รายการ",
        confirmButtonColor: "#0A66C2",
        confirmButtonText: "ตกลง",
      });
    } else {
      let postData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        if (key.slice(-2) === "Ar") {
          postData.append(key, JSON.stringify(detailSelectLawOccupation));
        } else {
          postData.append(key, value);
        }
      });
      try {
        const res = await fetch("api/ProposalBorrow/saveProposalBorrow3", { method: "POST", body: postData });
        const resJson = await res.json();
        if (resJson.status === 1) {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
              action.resetForm();
            }
          });
        } else {
          Swal.fire({
            icon: "error",
            title: `${resJson.message}`,
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
          });
        }
      } catch (e) {
        // console.log("err =>", e);
      } finally {
        setLoading(false);
      }
    }
  };

  // ===== Helpers: add / edit / delete row =====
  function OnDelete(row) {
    setDetailSelectLawOccupation((current) => current.filter((obj) => obj.id !== row.id));
  }

  function OnEdit(row) {
    // เปิดโมดัล “เลือกรายการ” พร้อมค่าที่เลือกไว้ (แก้ไข)
    setIsEditing(true);
    setSelectedItem(row);
    modalToggle();
  }

  const COLUMNS = [
    { Header: "ลำดับ", accessor: (_row, i) => i + 1 },
    { Header: "ผู้ขอกู้ยืมเงิน", accessor: "employee" },
    { Header: "สาขาอาชีพ", accessor: "lawOccupationName" },
    {
      Header: "จัดการ",
      accessor: "borrowId",
      Cell: ({ row }) => (
        <div className="text-center">
          <button type="button" className="btn border border-1 mx-1" onClick={() => OnEdit(row.original)}>
            แก้ไข
          </button>
          <button type="button" className="btn border border-1 mx-1" onClick={() => OnDelete(row.original)}>
            ลบ
          </button>
        </div>
      ),
    },
  ];

  // ====== บันทึกวันประชุมเฉพาะแถว ======
  const updateMeetingDate = async (borrowId) => {
    const chosen = pendingDates[borrowId];
    if (!chosen) {
      Swal.fire({ icon: "info", title: "กรุณาเลือกวันที่ประชุมใหม่", confirmButtonColor: "#0A66C2" });
      return;
    }
    try {
      setLoading(true);
      const form = new FormData();
      form.append("borrowId", Number(borrowId));
      form.append("meetingDate", toIsoDate(chosen));
      const res = await fetch("/api/ProposalBorrow/updateMeetingDate", { method: "POST", body: form });
      const js = await res.json();
      if (js.status === 1) {
        Swal.fire({ icon: "success", title: "อัปเดตวันที่ประชุมสำเร็จ", confirmButtonColor: "#0A66C2" });
        setEmployeeForChangeMeeting((prev) =>
          prev.map((it) => (String(it.borrowId) === String(borrowId) ? { ...it, meetingDate: form.get("meetingDate") } : it))
        );
      } else {
        Swal.fire({ icon: "error", title: js.message || "อัปเดตไม่สำเร็จ", confirmButtonColor: "#0A66C2" });
      }
    } catch (e) {
      console.error(e);
      Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาดในการอัปเดต", confirmButtonColor: "#0A66C2" });
    } finally {
      setLoading(false);
    }
  };

  // ====== ตัวเลือกฟิลเตอร์ในโมดัลแก้ไขวันประชุม ======
  const meetingNoOptions = useMemo(() => {
    const set = new Set();
    employeeForChangeMeeting.forEach((x) => x?.meetingNo && set.add(String(x.meetingNo)));
    return Array.from(set).sort();
  }, [employeeForChangeMeeting]);

  const meetingYearOptions = useMemo(() => {
    const set = new Set();
    employeeForChangeMeeting.forEach((x) => x?.meetingYear && set.add(String(x.meetingYear)));
    set.add("2569")
    return Array.from(set).sort();
  }, [employeeForChangeMeeting]);

  const filteredForEdit = useMemo(() => {
    return employeeForChangeMeeting.filter((x) => {
      const okNo = filterMeetingNo ? String(x.meetingNo) === String(filterMeetingNo) : true;
      const okYear = filterMeetingYear ? String(x.meetingYear) === String(filterMeetingYear) : true;
      return okNo && okYear;
    });
  }, [employeeForChangeMeeting, filterMeetingNo, filterMeetingYear]);

  // ====== ฟอร์มของโมดัล “เลือกรายการ” (เพิ่ม/แก้ไข) ======
  const selectDataInitialValues = { id: "", borrowId: "", employee: "", businessType: "", lawOccupationByCourse: "" };
  const selectDataValidateSchema = Yup.object().shape({
    borrowId: Yup.string().required("กรุณาเลือก"),
    lawOccupationByCourse: Yup.string().required("กรุณาเลือกสาขาอาชีพ"),
  });

  const onOpenAdd = () => {
    setIsEditing(false);
    setSelectedItem(null);
    setTimeout(() => modalToggle(), 0);
  };

  const selectDataOnsubmit = async (values, actions) => {
    // map ค่าที่เลือกเป็น object สำหรับตารางด้านล่าง
    const selectedBorrow = dataForSelect.find((b) => String(b.borrowId) === String(values.borrowId));
    const selectedOcc = lawOccupationData.find((o) => String(o.lawOccupationId) === String(values.lawOccupationByCourse));

    if (!selectedBorrow || !selectedOcc) return;

    const rowPayload = {
      id: values.id || uuidv4(),
      borrowId: selectedBorrow.borrowId,
      employee: selectedBorrow.employee,
      businessType: selectedBorrow.businessType ?? "-",
      lawOccupationId: selectedOcc.lawOccupationId,
      lawOccupationName: selectedOcc.lawOccupationName,
    };

    if (isEditing && values.id) {
      setDetailSelectLawOccupation((old) => old.map((r) => (r.id === values.id ? rowPayload : r)));
    } else {
      // กันซ้ำ borrowId เดิม
      const exists = detailSelectLawOccupation.some((r) => String(r.borrowId) === String(rowPayload.borrowId));
      if (exists) {
        Swal.fire({ icon: "warning", title: "ผู้ขอกู้รายนี้ถูกเพิ่มแล้ว", confirmButtonColor: "#0A66C2" });
        return;
      }
      setDetailSelectLawOccupation((prev) => [...prev, rowPayload]);
    }
    modalToggle();
  };

  const getInitialForModal = () => {
    if (!isEditing || !selectedItem) return selectDataInitialValues;
    // เตรียมค่าเดิมเพื่อแก้ไข
    return {
      id: selectedItem.id,
      borrowId: selectedItem.borrowId,
      employee: selectedItem.employee,
      businessType: selectedItem.businessType ?? "-",
      lawOccupationByCourse: selectedItem.lawOccupationId?.toString() || "",
    };
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validateSchema} onSubmit={onSubmit} enableReinitialize>
      {({ values, handleChange, handleBlur, setFieldValue, setValues, errors, touched }) => {
        return (
          <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
            {!loading ? (
              <div className="form-border" style={{ width: "100%" }}>
                <div className="d-flex justify-content-end mt-3 me-3">
                  {/* ปุ่มเปิดโมดัลแก้ไขข้อมูลวันที่ประชุม */}
                  <button type="button" className="btn-blue me-2" onClick={toggleEditMeetingModal}>
                    แก้ไขข้อมูลวันที่ประชุม
                  </button>
                  {/* ปุ่มเพิ่มรายการ (เลือกผู้ขอกู้ + สาขาอาชีพ) */}
                  <button type="button" className="btn-green text-white" onClick={onOpenAdd}>
                    <BsPlusLg className="mx-2" />
                    เลือกรายการ
                  </button>
                </div>

                {/* ====== Modal แก้ไขข้อมูลวันที่ประชุม ====== */}
                <Modal isOpen={openEditMeetingModal} toggle={toggleEditMeetingModal} style={{ maxWidth: "1400px", width: "100%" }} className="modal-bordered" centered backdrop={"static"} keyboard={false}>
                  <ModalHeader className="styled-modal text-center" toggle={toggleEditMeetingModal}>
                    แก้ไขข้อมูลวันที่ประชุม
                  </ModalHeader>
                  <ModalBody>
                    <div className="p-3">
                      <div className="row g-3">
                        <div className="col-md-4">
                          <Label className="mx-1">ครั้งที่ประชุม</Label>
                          <Input
                            type="select"
                            className="rounded-pill text-center input-color"
                            value={filterMeetingNo}
                            onChange={(e) => setFilterMeetingNo(e.target.value)}
                          >
                            <option value="">-- ทั้งหมด --</option>
                            {meetingNoOptions.map((no) => (
                              <option key={no} value={no}>
                                {no}
                              </option>
                            ))}
                          </Input>
                        </div>
                        <div className="col-md-4">
                          <Label className="mx-1">ปีที่ประชุม</Label>
                          <Input
                            type="select"
                            className="rounded-pill text-center input-color"
                            value={filterMeetingYear}
                            onChange={(e) => setFilterMeetingYear(e.target.value)}
                          >
                            <option value="">-- ทั้งหมด --</option>
                            {meetingYearOptions.map((y) => (
                              <option key={y} value={y}>
                                {y}
                              </option>
                              
                            ))}
                          </Input>
                        </div>
                      </div>

                      <div className="mt-4">
                        <Table className="styled-table" striped bordered hover responsive>
                          <thead className="bg bg-secondary text-center text-white" style={{ lineHeight: "2.6rem" }}>
                            <tr>
                              <th style={{ width: 70 }}>ลำดับ</th>
                              <th>ผู้ขอกู้ยืมเงิน</th>
                              <th>ครั้งที่ประชุม</th>
                              <th>ปีที่ประชุม</th>
                              <th>วันที่ประชุม (เดิม)</th>
                              <th>วันที่ประชุม (ใหม่)</th>
                              <th style={{ width: 180 }}>บันทึก</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredForEdit.length === 0 ? (
                              <tr>
                                <td colSpan={7} className="text-center py-4">
                                  ไม่พบข้อมูลตามเงื่อนไข
                                </td>
                              </tr>
                            ) : (
                              filteredForEdit.map((row, idx) => {
                                // แปลงวันที่เดิมเพื่อแสดงแบบ พ.ศ.
                                let oldDateDisplay = "";
                                if (row.meetingDate) {
                                  const d = new Date(row.meetingDate);
                                  const be = addYears(543, d);
                                  const monthInThai = format(be, "MMMM", { locale: th });
                                  oldDateDisplay = `${format(be, "d")} ${monthInThai} ${format(be, "yyyy")}`;
                                }

                                const chosen = pendingDates[row.borrowId] || null;

                                return (
                                  <tr key={row.borrowId} className="align-middle text-center">
                                    <td>{idx + 1}</td>
                                    <td className="text-start">{row.employee}</td>
                                    <td>{row.meetingNo}</td>
                                    <td>{row.meetingYear}</td>
                                    <td className="text-start">{oldDateDisplay || "-"}</td>
                                    <td>
                                      {(() => {
                                        const selected = chosen ?? null;
                                        const be = selected ? addYears(543, selected) : null;
                                        const displayValue = be
                                          ? `${format(be, "d")} ${format(be, "MMMM", { locale: th })} ${format(be, "yyyy")}`
                                          : "";

                                        return (
                                          <DatePicker
                                            selected={selected}
                                            onChange={(d) =>
                                              setPendingDates((p) => ({
                                                ...p,
                                                [row.borrowId]: d instanceof Date && !isNaN(+d) ? d : null,
                                              }))
                                            }
                                            isClearable
                                            placeholderText="เลือกวันที่"
                                            locale="th-buddhist"
                                            calendarClassName="thai-buddhist"
                                            renderCustomHeader={renderCustomHeader}
                                            onChangeRaw={(e) => e.preventDefault()}
                                            customInput={
                                              <CustomBuddhistInput
                                                className="rounded-pill text-center input-color"
                                                displayValue={displayValue}
                                              />
                                            }
                                          />
                                        );
                                      })()}
                                    </td>

                                    <td>
                                      <button type="button" className="btn-blue w-100" onClick={() => updateMeetingDate(row.borrowId)}>
                                        บันทึกวันประชุม
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </ModalBody>
                </Modal>
                {/* ====== END Modal แก้ไขข้อมูลวันที่ประชุม ====== */}

                <Form className="p-5 mb-4">
                  <FormGroup>
                    <Label className="mx-1">ครั้งที่ประชุม</Label>
                    <ErrorMessage name="meetingNo" component={TextErrors} />
                    <Field name="meetingNo">
                      {({ field, meta }) => (
                        <Input
                          type="text"
                          id="meetingNo"
                          className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                          {...field}
                        />
                      )}
                    </Field>
                  </FormGroup>

                  <FormGroup>
                    <Label className="mx-1">วันที่ประชุม</Label>
                    <ErrorMessage name="meetingDate" component={TextErrors} />
                    <Field name="meetingDate">
                      {({ field, meta, form }) => {
                        const selectedDate = field.value ? new Date(field.value) : null;
                        const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null;
                        const monthInThai = selectedDateInBE ? format(selectedDateInBE, "MMMM", { locale: th }) : null;
                        const formattedDate = selectedDateInBE ? `${format(selectedDateInBE, "dd")} ${monthInThai} ${format(selectedDateInBE, "yyyy")}` : "";

                        return (
                          <DatePicker
                            selected={selectedDate}
                            locale="th-buddhist"
                            showIcon
                            calendarClassName="thai-buddhist"
                            dateFormat="dd MMMM yyyy"
                            value={formattedDate}
                            isClearable
                            placeholderText="กรุณาเลือก"
                            renderCustomHeader={renderCustomHeader}
                            onChange={(date) => {
                              if (date instanceof Date && !isNaN(+date)) {
                                form.setFieldValue(field.name, toIsoDate(date));
                              } else {
                                form.setFieldValue(field.name, "");
                              }
                            }}
                            customInput={
                              <Input
                                type="text"
                                className={touched.cardExpireDate && errors.cardExpireDate ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                value={formattedDate}
                                onChange={() => { }}
                                onBlur={field.onBlur}
                              />
                            }
                          />
                        );
                      }}
                    </Field>
                  </FormGroup>

                  <FormGroup>
                    <Label className="mx-1">ปีที่ประชุม</Label>
                    <ErrorMessage name="meetingYear" component={TextErrors} />
                    <Field name="meetingYear">
                      {({ field, meta }) => (
                        <Input type="select" className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"} {...field}>
                          <option value="">กรุณาเลือกปี</option>
                          <option value={String(getCurrentYear)}>{getCurrentYear}</option>
                          <option value={String(getCurrentYear+1)}>{getCurrentYear+1}</option>

                        </Input>
                      )}
                    </Field>
                  </FormGroup>

                  {/* ===== ตารางรายการที่เลือกแล้ว ===== */}
                  <div className="mt-4">
                    <Table className="styled-table" striped bordered hover responsive>
                      <thead className="bg bg-secondary text-center text-white" style={{ lineHeight: "2.6rem" }}>
                        <tr>
                          <th style={{ width: 70 }}>ลำดับ</th>
                          <th>ผู้ขอกู้ยืมเงิน</th>
                          <th>สาขาอาชีพ</th>
                          <th style={{ width: 200 }}>จัดการ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detailSelectLawOccupation.length === 0 ? (
                          <tr>
                            <td colSpan={4} className="text-center py-4">ยังไม่ได้เลือกรายการ</td>
                          </tr>
                        ) : (
                          detailSelectLawOccupation.map((row, i) => (
                            <tr key={row.id}>
                              <td className="text-center">{i + 1}</td>
                              <td>{row.employee}</td>
                              <td>{row.lawOccupationName}</td>
                              <td className="text-center">
                                <button type="button" className="btn border border-1 mx-1" onClick={() => OnEdit(row)}>
                                  แก้ไข
                                </button>
                                <button type="button" className="btn border border-1 mx-1" onClick={() => OnDelete(row)}>
                                  ลบ
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>

                  <FormGroup className="d-flex justify-content-center align-items-center mt-3">
                    <button type="submit" className="btn-blue w-25">
                      ยืนยัน
                    </button>
                  </FormGroup>
                </Form>

                {/* ===== Modal: เลือกรายการ (เลือกผู้ขอกู้ + สาขาอาชีพ) ===== */}
                <Formik
                  initialValues={getInitialForModal()}
                  validationSchema={selectDataValidateSchema}
                  onSubmit={selectDataOnsubmit}
                  enableReinitialize
                >
                  {({ values, setFieldValue, touched, errors }) => {
                    const findBusinessType = () => {
                      const borrow = dataForSelect.find(item => String(item.borrowId) === String(values.borrowId));
                      return borrow?.businessType ?? "-";
                    };

                    return (
                      <Modal isOpen={openModalForm} toggle={modalToggle} style={{ maxWidth: "600px", width: "100%" }} className="modal-bordered" centered backdrop={"static"} keyboard={false}>
                        <ModalHeader className="styled-modal text-center" toggle={modalToggle}>
                          {isEditing ? "แก้ไขรายการ" : "เลือกรายการ"}
                        </ModalHeader>
                        <ModalBody className="form-border">
                          <div>
                            <Form autoComplete="off">
                              <div className="p-4">
                                <FormGroup>
                                  <div className="w-100">
                                    <Field name="id" style={{ display: "none" }} />
                                    <Label>รายชื่อผู้ขอกู้ยืมเงิน</Label>
                                    {touched.borrowId && errors.borrowId ? <span className="text-left text-danger px-1">{errors.borrowId}</span> : null}
                                    <Field name="borrowId">
                                      {({ field, meta }) => (
                                        <Input
                                          type="select"
                                          className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                          {...field}
                                          disabled={isEditing} // ไม่ให้แก้ borrow เมื่ออยู่โหมดแก้ไข
                                        >
                                          <option value="">--กรุณาเลือก--</option>
                                          {dataForSelect.map((borrow, i) => (
                                            <option key={i} value={borrow.borrowId}>
                                              {borrow.employee}
                                            </option>
                                          ))}
                                        </Input>
                                      )}
                                    </Field>

                                    <Label className={"mt-3"}>ประเภทกิจการ</Label>
                                    <Field name="businessType">
                                      {({ field }) => (
                                        <Input type="text" className="rounded-pill text-center input-color" {...field} disabled value={findBusinessType()} />
                                      )}
                                    </Field>

                                    <Label className={"mt-3"}>สาขาอาชีพ</Label>
                                    {touched.lawOccupationByCourse && errors.lawOccupationByCourse ? <span className="text-left text-danger px-1">{errors.lawOccupationByCourse}</span> : null}
                                    <Field name={`lawOccupationByCourse`}>
                                      {({ field, meta }) => (
                                        <Input
                                          type="select"
                                          className={
                                            meta.touched && meta.error
                                              ? "input-error rounded-pill text-center input-color border border-1 w-100"
                                              : "rounded-pill text-center input-color border border-1 w-100"
                                          }
                                          {...field}
                                        >
                                          <option value="">--กรุณาเลือก--</option>
                                          {lawOccupationData.map((item) => (
                                            <option key={item.lawOccupationId} value={item.lawOccupationId}>
                                              {item.lawOccupationName}
                                            </option>
                                          ))}
                                        </Input>
                                      )}
                                    </Field>
                                  </div>
                                </FormGroup>

                                <div className="d-flex justify-content-center align-items-center">
                                  <button type="submit" disabled={!values.borrowId || !values.lawOccupationByCourse} className="btn-blue w-50 mt-2">
                                    {isEditing ? "บันทึกการแก้ไข" : "เพิ่มรายการ"}
                                  </button>
                                </div>
                              </div>
                            </Form>
                          </div>
                        </ModalBody>
                      </Modal>
                    );
                  }}
                </Formik>
                {/* ===== END Modal เลือกรายการ ===== */}
              </div>
            ) : (
              <Loading />
            )}
          </Container>
        );
      }}
    </Formik>
  );
}
